import { motion } from "framer-motion";
import { ShieldCheck, GraduationCap, Briefcase } from "lucide-react";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Sicurezza",
    body: "DVR, valutazione dei rischi specifici, adempimenti e obblighi previsti dal D.Lgs. 81/08.",
  },
  {
    icon: GraduationCap,
    title: "Formazione",
    body: "Corsi e aggiornamenti per lavoratori, aziende e figure della sicurezza, in presenza e su tutto il territorio nazionale.",
  },
  {
    icon: Briefcase,
    title: "Consulenza",
    body: "Supporto nella gestione della sicurezza, certificazioni, FGAS, bandi regionali e soluzioni dedicate alle aziende.",
  },
];

export const Pillars = () => {
  return (
    <section data-testid="pillars-section" className="bg-brand-paper py-16 md:py-20 border-b border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-5xl mb-10">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-4">
            Non vendiamo un prodotto, vendiamo un servizio
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-5xl tracking-tighter text-brand-black leading-[0.98]">
            Sicurezza, formazione e bandi: un rapporto che continua nel tempo.
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.article
                key={p.title}
                data-testid={`pillar-${i}`}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className={`bg-white border border-border p-5 md:p-6 hover:border-brand-red transition-colors ${i === 2 ? "sm:col-span-2 lg:col-span-1" : ""}`}
              >
                <div className="w-12 h-12 mb-5 flex items-center justify-center bg-brand-black text-white">
                  <Icon size={22} />
                </div>
                <h3 className="font-heading font-bold text-xl md:text-2xl text-brand-black leading-tight mb-3">
                  {p.title}
                </h3>
                <p className="text-brand-ink text-sm md:text-base leading-relaxed">{p.body}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
